import { CdkVirtualScrollViewport } from "@angular/cdk/scrolling";
import { AfterContentInit, Directive, Optional, SkipSelf } from "@angular/core";
import { MatExpansionPanel } from "@angular/material/expansion";
import { logger } from "@app/_helpers/logger";
import { nextTick } from "@app/_helpers/utils";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

const log = logger.child("MatExpandableVirtualItemDirective");
// updates cdk virtual scroll viewport size when expansion panel is expanded or collapsed
@UntilDestroy()
@Directive({
	selector: "mat-expansion-panel[mat-virtual-expandable-item],mat-expansion-panel[matVirtualExpandable]",
})
export class MatExpandableVirtualItemDirective implements AfterContentInit {
	constructor(
		private parent: MatExpansionPanel,
		@Optional()
		@SkipSelf()
		private virtualScrollViewport?: CdkVirtualScrollViewport
	) {
		log.debug("MatExpandableVirtualItemDirective", { virtualScrollViewport: this.virtualScrollViewport });
	}

	ngAfterContentInit() {
		if (!this.virtualScrollViewport) {
			log.debug("no virtual scroll viewport");
			return;
		}
		this.parent.expandedChange.pipe(untilDestroyed(this)).subscribe(() => {
			nextTick(() => {
				this.virtualScrollViewport.checkViewportSize();
				log.debug("checking viewport size", this.virtualScrollViewport);
			});
		});
	}
}
